import React from 'react';
import { string, bool, shape } from 'prop-types';

const RevisedAndPublished = ({
  revisedAsPublished,
  isNew,
  translations,
  eventDate,
  subjectHeading,
}) => {
  const Date = () => {
    return isNew || revisedAsPublished ? (
      <p className="new">
        {translations.published} <span>{eventDate}</span>
      </p>
    ) : (
      <p className="revised">
        {translations.revised} <span>{eventDate}</span>
      </p>
    );
  };

  return (
    <div className="revised-and-published">
      {eventDate && <Date />}
      {subjectHeading && (
        <p>
          {translations.subject} <span>{subjectHeading}</span>
        </p>
      )}
    </div>
  );
};

RevisedAndPublished.propTypes = {
  eventDate: string,
  revisedAsPublished: bool,
  isNew: bool,
  subjectHeading: string,
  translations: shape({
    subject: string,
    published: string,
    revised: string,
  }),
};

export default RevisedAndPublished;
